import api from "./axios.factory";

class CaliberService {
  async listCalibers(params) {
    const result = await api.get("/calibers", { params });
    return result.data;
  }

  async getCaliber(id) {
    const result = await api.get(`/calibers/${id}`);
    return result.data.data;
  }

  async getCaliberImages(id) {
    const result = await api.get(`/calibers/${id}/images`);
    return result.data.data ?? [];
  }
}

export default new CaliberService();
